import { makeStyles } from "tss-react/mui";
import {
  DATE_TIME_FORMATS,
  ORDER_STATUS_BORDER_COLORS,
  WORK_ORDER_STATUSES,
  WORK_ORDER_STATUSES_DISPLAY,
  WORK_ORDER_STATUS_COLORS,
} from "@miplatform/constants";
import { IAttemptListItemResponseForWorkOrder } from "@miplatform/types";
import {
  convertTimeToWorkOrderShortHandTime,
  toFormattedDate,
} from "@miplatform/utils";
import { Info } from "@mibuildweb/components";
import { Box } from "@mui/system";

export const WorkOrderDrawerSubheader = ({
  workOrder,
}: WorkOrderDrawerSubHeaderProps) => {
  const { workOrderStatus, assignedUserName, startDate, assignment, endDate } =
    workOrder;
  const status = workOrderStatus || WORK_ORDER_STATUSES.NEW;

  const { classes } = useStyles({
    statusColor: WORK_ORDER_STATUS_COLORS[status],
    statusBorderColor: ORDER_STATUS_BORDER_COLORS[status],
  });

  return (
    <Box className={classes.root}>
      <Box className={classes.statusContainer}>
        <Info
          text="Work Order Status"
          subtext={WORK_ORDER_STATUSES_DISPLAY[status]}
          descriptionColor={WORK_ORDER_STATUS_COLORS[status]}
        />
      </Box>
      <Box className={classes.infoContainer}>
        <Info
          text="Due Date"
          subtext={
            assignment?.workOrder?.hardDueDate
              ? convertTimeToWorkOrderShortHandTime(
                  assignment.workOrder.hardDueDate
                )
              : "--/--/----"
          }
        />
        <Info
          text="Start Date"
          subtext={toFormattedDate(
            startDate,
            DATE_TIME_FORMATS.FORMAT_MM_DD_YYYY
          )}
        />
        <Info
          text="Complete Date"
          subtext={toFormattedDate(
            endDate,
            DATE_TIME_FORMATS.FORMAT_MM_DD_YYYY
          )}
        />
        <Info text="Assignee" subtext={assignedUserName} />
      </Box>
    </Box>
  );
};

interface WorkOrderDrawerSubHeaderProps {
  workOrder: IAttemptListItemResponseForWorkOrder;
}

const useStyles = makeStyles<{
  statusColor: string;
  statusBorderColor: string;
}>()((theme, { statusColor, statusBorderColor }) => ({
  viewContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    height: "100%",
  },
  content: {
    padding: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    overflow: "auto",
    height: "100%",
  },
  tabContainer: {
    borderBottom: `1px solid ${theme.palette.grey.medium}`,
    paddingVertical: theme.spacing(2),
  },
  root: {
    display: "flex",
    gap: theme.spacing(4),
    alignItems: "center",
    borderRadius: theme.spacing(0.5),
    border: `1px solid ${statusBorderColor}`,
    backgroundColor: `${statusColor}1A`,
  },
  statusContainer: {
    padding: theme.spacing(2, 7, 2, 4),
    height: "100%",
    alignContent: "center",
    backgroundColor: `${statusColor}2A`,
    borderRight: `1px solid ${statusBorderColor}`,
  },
  infoContainer: {
    display: "grid",
    gap: theme.spacing(8),
    padding: theme.spacing(1, 3),
    alignItems: "center",
    gridTemplateColumns: "1fr 1fr 1fr 1fr",
    overflow: "hidden",
  },
  timelineContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  tabContent: {
    marginTop: theme.spacing(2),
  },
  workOrderCard: {
    backgroundColor: theme.palette.grey.light,
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.grey.accent}`,
  },
}));
